export const PURCHASE_STATUS_LABELS: Record<string, string> = {
  draft: "Черновик",
  signed: "Подписано",
};
